import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'
import '@/styles/main.css'

// Create Vue app instance
const app = createApp(App)

// Initialize state management
app.use(createPinia())

// Initialize routing
app.use(router)

// Mount app
app.mount('#app')
